if (!customElements.get('set-form')) {
  class SetForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.submitButton = this.querySelector('[name="add"]');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.atcBar = document.querySelector('atc-bar');

      this.#setButtonState();

      this.querySelector('form')?.addEventListener(
        'submit',
        (event) => this.#onSubmitHandler(event)
      );

      /**
       * Update button state.
       */
      this.querySelectorAll('form input, form select').forEach(
        (input) => {
          input.addEventListener('change', (event) => {
            this.#setButtonState();
          });
        }
      );
    }

    /**
     * Handle form submit.
     *
     * @param {Event} event
     * @returns {Void}
     */
    #onSubmitHandler = (event) => {
      event.preventDefault();

      const isInvalid = Array.from(
        event.target.querySelectorAll('[required]')
      ).some((field) => !field.checkValidity());

      if (isInvalid) {
        alert('Please select a size!');
        return;
      }

      this.#setProductsHash();
      this.submitButton.classList.add('disabled');
      
      if (this.atcBar) {
        const submitButton = this.atcBar.querySelector('[data-submit-button]');

        submitButton?.setAttribute('disabled', true);
        submitButton?.classList.add('disabled');
      }

      /**
       * Configure request data.
       */
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(event.target);
      formData.append(
        'sections',
        this.cartDrawer
          .getSectionsToRender()
          .map((section) => section.section)
      );
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      /**
       * Add products to cart.
       */
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }

          this.closest('.set-modal')?.hide();
          this.cartDrawer.renderContents(response);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.submitButton.classList.remove('disabled');

          if (this.atcBar) {
            const submitButton = this.atcBar.querySelector('[data-submit-button]');
    
            submitButton?.removeAttribute('disabled');
            submitButton?.classList.remove('disabled');
          }

          this.dispatchEvent(
            new CustomEvent('set-form:atc-complete', {
              bubbles: true,
              details: {
                form: this
              }
            })
          );
        });
    };

    /**
     * Give each product a hash that is unique to the current set.
     *
     * @returns {Void}
     */
    #setProductsHash = () => {
      const idInputs = this.querySelectorAll('[name*=_set]:not([name*=_set-])');

      if (idInputs.length === 0) return;

      const hash = generateString(4);
      idInputs.forEach(
        (input) =>
          (input.value = input.value.split('|')[0] += `|${hash}`)
      );
    };

    /**
     * Set button active/disabled state based on whether
     * all products have a selected color.
     */
    #setButtonState = () => {
      const button = this.querySelector('[name="add"]');
      let hasSelectedRadios = true;
      let hasSelectedOptions = true;
      let unselectedOption = '';
      let setTotalPrice = 0;

      if (!button) return;

      const products = this.querySelectorAll('set-product');

      for (const product of products) {
        const options = product.querySelectorAll('[data-option]');
        
        setTotalPrice += parseFloat(product.getAttribute('final-price'));

        for (const option of options) {
          const hasCurrentSelectedRadios = !!option.querySelector('input:checked');
          const hasCurrentSelectedOptions = option.querySelector('select')?.value !== '';

          if (!hasCurrentSelectedRadios && !hasCurrentSelectedOptions && unselectedOption === '') {
            unselectedOption = option.dataset.optionName;
          }

          if (!hasCurrentSelectedRadios) {
            hasSelectedRadios = hasCurrentSelectedRadios;
          }

          if (!hasCurrentSelectedOptions) {
            hasSelectedOptions = hasCurrentSelectedOptions;
          }
        }
      }

      if (hasSelectedRadios || hasSelectedOptions) {
        button.innerHTML = button.dataset.enabled;

        button.removeAttribute('disabled');

        if (this.atcBar) {
          this.atcBar.querySelector('modal-opener')?.classList.add('hidden');
          this.atcBar.querySelector('[data-submit-button]')?.classList.remove('hidden');
        }
      } else {
        const priceString = Shopify.formatMoney(
          setTotalPrice,
          Shopify.current_money_format
        );

        button.innerHTML = `${window.variantStrings.chooseOption.replace('[option_name]', unselectedOption)} <small>${priceString}</small>`; 
      }
    };
  }
  customElements.define('set-form', SetForm);
}
